import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import GlossaryManager from './GlossaryManager';
import ActivityManager from "./ActivityManager";

class GlossaryStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return [];
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.GLOSSARY_GET_ALL_TERMS:
        GlossaryManager.getAllTerms();
        return state;

      case ActionTypes.GLOSSARY_GET_ALL_TERMS_COMPLETED:
        return action.glossary;

      case ActionTypes.GLOSSARY_VIEW_TERM:
        ActivityManager.saveActivity({
            glossary_id: action.glossaryId,
            event_type: 'glossary_term_viewed'
          },
          'glossary-activities'
        );
        return state;

      default:
        return state;
    }
  }
}

export default new GlossaryStore();
